/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import mangolevel1 from '@assets/images/mango_icons/level_1.png';
import mangolevel2 from '@assets/images/mango_icons/level_2.png';
import mangolevel3 from '@assets/images/mango_icons/level_3.png';
import mangolevel4 from '@assets/images/mango_icons/level_4.png';
import mangolevel5 from '@assets/images/mango_icons/level_5.png';
import mangolevel6 from '@assets/images/mango_icons/level_6.png';
import mangolevel7 from '@assets/images/mango_icons/level_7.png';
import mangolevel8 from '@assets/images/mango_icons/level_8.png';
import mangolevel9 from '@assets/images/mango_icons/level_9.png';
import mangolevel10 from '@assets/images/mango_icons/level_10.png';
import mangolevel11 from '@assets/images/mango_icons/level_11.png';
import mangolevel12 from '@assets/images/mango_icons/level_12.png';
import mangolevel13 from '@assets/images/mango_icons/level_13.png';
import mangolevel14 from '@assets/images/mango_icons/level_14.png';
import mangolevel15 from '@assets/images/mango_icons/level_15.png';
import mangolevel16 from '@assets/images/mango_icons/level_16.png';
import mangolevel17 from '@assets/images/mango_icons/level_17.png';
import mangolevel18 from '@assets/images/mango_icons/level_18.png';
import mangolevel19 from '@assets/images/mango_icons/level_19.png';
import mangolevel20 from '@assets/images/mango_icons/level_20.png';

function MangoLevel({ level, width }) {
  function Mango({ src }) {
    return (
      <img src={src} width={width} alt='mango' />
    );
  }

  return (
    <>
      { // Mango icon
        (() => {
          switch (level) {
          case 1:
            return (
              <Mango src={mangolevel1} />
            );
          case 2:
            return (
              <Mango src={mangolevel2} />
            );
          case 3:
            return (
              <Mango src={mangolevel3} />
            );
          case 4:
            return (
              <Mango src={mangolevel4} />
            );
          case 5:
            return (
              <Mango src={mangolevel5} />
            );
          case 6:
            return (
              <Mango src={mangolevel6} />
            );
          case 7:
            return (
              <Mango src={mangolevel7} />
            );
          case 8:
            return (
              <Mango src={mangolevel8} />
            );
          case 9:
            return (
              <Mango src={mangolevel9} />
            );
          case 10:
            return (
              <Mango src={mangolevel10} />
            );
          case 11:
            return (
              <Mango src={mangolevel11} />
            );
          case 12:
            return (
              <Mango src={mangolevel12} />
            );
          case 13:
            return (
              <Mango src={mangolevel13} />
            );
          case 14:
            return (
              <Mango src={mangolevel14} />
            );
          case 15:
            return (
              <Mango src={mangolevel15} />
            );
          case 16:
            return (
              <Mango src={mangolevel16} />
            );
          case 17:
            return (
              <Mango src={mangolevel17} />
            );
          case 18:
            return (
              <Mango src={mangolevel18} />
            );
          case 19:
            return (
              <Mango src={mangolevel19} />
            );
          case 20:
            return (
              <Mango src={mangolevel20} />
            );
          default:
            return null;
          } // End switch
        })() // End Arrow Function

      }
    </>
  );
}

MangoLevel.defaultProps = {
  width: '18px',
};

export default MangoLevel;
